import * as React from 'react'
import { useState, useEffect } from 'react';
// ─────────────────────────────────────────────
// COMPONENT 2: TypewriterSubtitle
// PLACEMENT: Replace <p className="sub"> in your hero section
// Usage: <TypewriterSubtitle />
// ─────────────────────────────────────────────
const TW_WORDS = [
  "manufacturing",
  "healthcare",
  "logistics",
  "finance & SaaS",
  "retail",
  "operations",
];

export function TypewriterSubtitle() {
  const [displayed, setDisplayed] = useState("");
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const word = TW_WORDS[wordIndex];
    let timeout;

    if (!deleting) {
      if (charIndex < word.length) {
        timeout = setTimeout(() => setCharIndex((c) => c + 1), 90);
      } else {
        timeout = setTimeout(() => setDeleting(true), 1600);
      }
    } else {
      if (charIndex > 0) {
        timeout = setTimeout(() => setCharIndex((c) => c - 1), 55);
      } else {
        setDeleting(false);
        setWordIndex((w) => (w + 1) % TW_WORDS.length);
        timeout = setTimeout(() => {}, 300);
      }
    }

    setDisplayed(word.slice(0, charIndex));
    return () => clearTimeout(timeout);
  }, [charIndex, deleting, wordIndex]);

  return (
    <>
      <style>{`
        .rs-tw-wrap { font-size: 19px; max-width: 560px; margin: 0 auto 40px; color: var(--gray); }
        .rs-tw-static { color: var(--gray); }
        .rs-tw-word {
          color: var(--secondary);
          font-weight: 600;
          border-right: 2px solid var(--secondary);
          padding-right: 3px;
          animation: rsTwBlink 0.7s step-end infinite;
        }
        @keyframes rsTwBlink { 50% { border-color: transparent; } }
      `}</style>
      <p className="rs-tw-wrap">
        <span className="rs-tw-static">
          Readal builds AI, ERP, and cloud systems for{" "}
        </span>
        <span className="rs-tw-word">{displayed}</span>
        <span className="rs-tw-static"> companies that refuse to slow down.</span>
      </p>
    </>
  );
}
